import React from 'react';
import { Switch, Route, useLocation, useRouteMatch, matchPath } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Page from 'components/Page';
import PageContainer from 'components/PageContainer';
import joinPath from 'utilities/joinPath';

import Levels from './Levels';
import Unit from './Unit';


const ApartmentsTemplate = ({ page }) => {
    const location = useLocation();
    const match = useRouteMatch();

    const unitPathPattern = joinPath(match.path, ':levelSlug', ':unitSlug');

    const isUnit = matchPath(location.pathname, {
        path: unitPathPattern,
        exact: true,
    });
    
    return (
        <Page>
            <PageContainer>
                <AnimatePresence>
                    <Switch location={location} key={isUnit ? 'unit' : 'levels'}>
                        <Route path={unitPathPattern}>
                            <Unit/>
                        </Route>
                        <Route path={match.path}>
                            <Levels page={page}/>
                        </Route>
                    </Switch>
                </AnimatePresence>
            </PageContainer>
        </Page>
    );
};


export default ApartmentsTemplate;
